// 侧边导航分类
// 目前两级 superLayer otherLayer
export const sidebarLayer = {
  superLayer: 'superLayer',
  otherLayer: 'otherLayer',
  approvalsLayer: 'approvalsLayer'
}
